import { usePageTitle } from '../hooks/usePageTitle';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { fotoUrl } from '../api';
import { useAuth, useIzin } from '../AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const Egitmenler: React.FC = () => {
  usePageTitle('Eğitmenler');
  const navigate = useNavigate();
  const { kullanici, subeGirisi } = useAuth();
  const isSuperAdmin = kullanici?.rol === 'super_admin' || subeGirisi !== null;
  const canManageEgitmen = useIzin('egitmen_yonetim');
  const { isDark } = useTheme();
  const card        = isDark ? '#1a1a1a' : 'white';
  const cardAlt     = isDark ? '#1e1e1e' : '#f8f8f8';
  const cardHover   = isDark ? '#252525' : '#fafafa';
  const border      = isDark ? '#2a2a2a' : '#eee';
  const borderSub   = isDark ? '#202020' : '#f0f0f0';
  const textPrimary = isDark ? '#e8e8e8' : '#1a1a1a';
  const textSec     = isDark ? '#999'    : '#888';
  const textMuted   = isDark ? '#666'    : '#aaa';
  const [egitmenler, setEgitmenler] = useState<any[]>([]);
  const [bekleyenMap, setBekleyenMap] = useState<Record<string, number>>({});
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modal, setModal] = useState(false);
  const [duzenle, setDuzenle] = useState<any>(null);
  const [form, setForm] = useState({ ad:'', soyad:'', email:'', tel:'', uzmanlik:'', bio:'', cinsiyet:'', dogum_tarihi:'' });
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [silOnay, setSilOnay] = useState<any>(null);
  const [siliyor, setSiliyor] = useState(false);
  const RENKLER = [['#EEEDFE','#3C3489'],['#E1F5EE','#085041'],['#FBEAF0','#72243E'],['#FAEEDA','#854F0B'],['#E6F1FB','#0C447C']];

  const yukle = () => {
    setYukleniyor(true);
    Promise.all([
      api.get('/api/egitmenler'),
      api.get('/api/hakedis/').catch(() => ({ data: [] })),
    ])
      .then(([eRes, hRes]) => {
        setEgitmenler(eRes.data);
        const map: Record<string, number> = {};
        hRes.data.forEach((h: any) => { map[h.id] = parseFloat(h.bekleyen || 0); });
        setBekleyenMap(map);
      })
      .finally(() => setYukleniyor(false));
  };
  useEffect(() => { yukle(); }, []);

  const ac = (e?: any) => {
    setDuzenle(e||null);
    setForm(e ? { ad:e.ad, soyad:e.soyad, email:e.email, tel:e.tel||'', uzmanlik:(e.uzmanlik||[]).join(', '), bio:e.bio||'', cinsiyet:e.cinsiyet||'', dogum_tarihi:e.dogum_tarihi?.slice(0,10)||'' }
              : { ad:'', soyad:'', email:'', tel:'', uzmanlik:'', bio:'', cinsiyet:'', dogum_tarihi:'' });
    setHata(''); setModal(true);
  };

  const sil = async () => {
    if (!silOnay) return;
    setSiliyor(true);
    try {
      await api.delete(`/api/egitmenler/${silOnay.id}`);
      setSilOnay(null);
      yukle();
    } catch (err: any) { alert(err.response?.data?.hata || 'Silinemedi'); }
    finally { setSiliyor(false); }
  };

  const kaydet = async () => {
    if (!form.ad||!form.soyad||!form.email) { setHata('Ad, soyad ve email zorunlu'); return; }
    setKaydediliyor(true); setHata('');
    try {
      const data = { ...form, uzmanlik: form.uzmanlik.split(',').map((u:string)=>u.trim()).filter(Boolean) };
      if (duzenle) await api.put(`/api/egitmenler/${duzenle.id}`, data);
      else await api.post('/api/egitmenler', data);
      setModal(false); yukle();
    } catch (err:any) { setHata(err.response?.data?.hata||'Hata oluştu'); }
    finally { setKaydediliyor(false); }
  };

  return (
    <div style={{ padding:24 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <h1 style={{ fontSize:22, fontWeight:600, margin:0 }}>Eğitmenler</h1>
        {canManageEgitmen && <button onClick={() => ac()} style={{ background:'#534AB7', color:'white', border:'none', padding:'8px 16px', borderRadius:6, cursor:'pointer', fontSize:13 }}>+ Eğitmen ekle</button>}
      </div>
      {yukleniyor ? <div style={{ textAlign:'center', color:textSec, padding:40 }}>Yükleniyor...</div> : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:12 }}>
          {egitmenler.map((e,i) => {
            const [bg,tc] = RENKLER[i%RENKLER.length];
            return (
              <div key={e.id} style={{ background:card, border:`1px solid ${border}`, borderRadius:10, padding:16, cursor:'pointer', transition:'box-shadow .15s' }}
                onClick={() => navigate(`/egitmenler/${e.id}`)}
                onMouseEnter={ev => (ev.currentTarget.style.boxShadow='0 2px 8px rgba(0,0,0,.08)')}
                onMouseLeave={ev => (ev.currentTarget.style.boxShadow='none')}>
                <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:10 }}>
                  {e.foto_url ? <img src={fotoUrl(e.foto_url)} alt="" style={{ width:44, height:44, borderRadius:'50%', objectFit:'cover' }} />
                    : <div style={{ width:44, height:44, borderRadius:'50%', background:bg, color:tc, display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, fontWeight:600 }}>{e.ad.charAt(0)}{e.soyad.charAt(0)}</div>}
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:600, fontSize:14 }}>{e.ad} {e.soyad}</div>
                    <div style={{ fontSize:11, color:textMuted }}>{e.email}</div>
                  </div>
                  {bekleyenMap[e.id] !== undefined && (
                    <span style={{
                      background: bekleyenMap[e.id] > 0 ? (isDark ? 'rgba(245,158,11,0.15)' : '#FAEEDA') : (isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE'),
                      color: bekleyenMap[e.id] > 0 ? '#854F0B' : '#3B6D11',
                      borderRadius: 20, padding: '2px 8px', fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' as const
                    }}>
                      ₺{Number(bekleyenMap[e.id]).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                    </span>
                  )}
                </div>
                {e.uzmanlik?.length > 0 && (
                  <div style={{ display:'flex', flexWrap:'wrap', gap:4, marginBottom:8 }}>
                    {e.uzmanlik.map((u:string,ui:number) => <span key={ui} style={{ background:isDark ? '#222222' : '#f0f0f0', color:isDark ? '#bbb' : '#555', borderRadius:20, padding:'2px 8px', fontSize:11 }}>{u}</span>)}
                  </div>
                )}
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:8 }}>
                  <span style={{ background:isDark ? '#222222' : '#f0f0f0', color:isDark ? '#999' : '#666', borderRadius:20, padding:'2px 8px', fontSize:11 }}>{e.ders_sayisi} ders</span>
                  <div style={{ display:'flex', gap:6 }}>
                    {isSuperAdmin && (
                      <button onClick={ev => { ev.stopPropagation(); setSilOnay(e); }}
                        style={{ border:'1px solid #ffcccc', background:'#fff5f5', color:'#c0392b', padding:'4px 10px', borderRadius:6, cursor:'pointer', fontSize:11 }}>
                        Sil
                      </button>
                    )}
                    {canManageEgitmen && <button onClick={ev => { ev.stopPropagation(); ac(e); }} style={{ border:`1px solid ${border}`, background:card, padding:'4px 10px', borderRadius:6, cursor:'pointer', fontSize:11 }}>Düzenle</button>}
                  </div>
                </div>
              </div>
            );
          })}
          {egitmenler.length===0 && <div style={{ gridColumn:'1/-1', textAlign:'center', padding:40, color:textMuted, background:card, borderRadius:10, border:'1px dashed #ddd' }}>Henüz eğitmen eklenmedi.</div>}
        </div>
      )}
      {silOnay && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200 }}
          onClick={e => { if (e.target===e.currentTarget) setSilOnay(null); }}>
          <div style={{ background:card, borderRadius:12, padding:28, width:400 }}>
            <div style={{ fontSize:16, fontWeight:700, marginBottom:8, color:'#c0392b' }}>Eğitmeni sil</div>
            <div style={{ fontSize:13, color:isDark ? '#bbb' : '#555', marginBottom:6 }}>
              <strong>{silOnay.ad} {silOnay.soyad}</strong> adlı eğitmen kalıcı olarak silinecek.
            </div>
            <div style={{ fontSize:12, color:'#e74c3c', background:'#fff5f5', border:'1px solid #ffcccc', borderRadius:8, padding:'10px 12px', marginBottom:20 }}>
              Bu işlem geri alınamaz. Eğitmenin ders bağlantıları ve hakediş kayıtları da silinir.
            </div>
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
              <button onClick={() => setSilOnay(null)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background:card, cursor:'pointer', fontSize:13 }}>İptal</button>
              <button onClick={sil} disabled={siliyor}
                style={{ padding:'8px 16px', borderRadius:6, border:'none', background:'#c0392b', color:'white', cursor:'pointer', fontSize:13, fontWeight:600 }}>
                {siliyor ? 'Siliniyor...' : 'Evet, sil'}
              </button>
            </div>
          </div>
        </div>
      )}

      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 }}
          onClick={e => { if (e.target===e.currentTarget) setModal(false); }}>
          <div style={{ background:card, borderRadius:12, padding:24, width:420 }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:16 }}>{duzenle?'Eğitmeni düzenle':'Yeni eğitmen ekle'}</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
              {[['Ad','ad','Örn: Elena'],['Soyad','soyad','Örn: Russo']].map(([l,k,p])=>(
                <div key={k}>
                  <div style={{ fontSize:11, color:textSec, marginBottom:4 }}>{l}</div>
                  <input value={(form as any)[k]} onChange={e=>setForm(p2=>({...p2,[k]:e.target.value}))} placeholder={p}
                    style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
                </div>
              ))}
            </div>
            {[['E-posta','email','ornek@gmail.com'],['Telefon','tel','05xx xxx xx xx'],['Uzmanlık (virgülle)','uzmanlik','Tango, Vals'],['Biyografi','bio','Kısa tanıtım']].map(([l,k,p])=>(
              <div key={k} style={{ marginBottom:10 }}>
                <div style={{ fontSize:11, color:textSec, marginBottom:4 }}>{l}</div>
                <input value={(form as any)[k]} onChange={e=>setForm(p2=>({...p2,[k]:e.target.value}))} placeholder={p}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
              </div>
            ))}
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4 }}>Cinsiyet</div>
                <select value={form.cinsiyet} onChange={e=>setForm(p=>({...p,cinsiyet:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                  <option value=''>—</option>
                  <option value='kadin'>Kadın</option>
                  <option value='erkek'>Erkek</option>
                  <option value='diger'>Diğer</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4 }}>Doğum tarihi</div>
                <input type='date' value={form.dogum_tarihi} onChange={e=>setForm(p=>({...p,dogum_tarihi:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
              </div>
            </div>
            {hata && <div style={{ background:isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB', color:'#A32D2D', padding:'8px 12px', borderRadius:6, fontSize:12, marginBottom:10 }}>{hata}</div>}
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button onClick={() => setModal(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background:card, cursor:'pointer', fontSize:13 }}>İptal</button>
              <button onClick={kaydet} disabled={kaydediliyor} style={{ padding:'8px 16px', borderRadius:6, border:'none', background:'#534AB7', color:'white', cursor:'pointer', fontSize:13 }}>
                {kaydediliyor?'Kaydediliyor...':duzenle?'Güncelle':'Ekle'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Egitmenler;
